"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAsyncRedux = createAsyncRedux;
exports.createDeleteAsyncRedux = createDeleteAsyncRedux;
exports.createGetAsyncRedux = createGetAsyncRedux;
exports.createPatchAsyncRedux = createPatchAsyncRedux;
exports.createPostAsyncRedux = createPostAsyncRedux;
exports.createPutAsyncRedux = createPutAsyncRedux;
const lib_1 = require("../reducers/lib.js");
const lib_2 = require("../state/lib.js");
const sonar_http_1 = require("@sonar-software/sonar-http");
const lib_3 = require("../actionCreators/lib.js");
const lib_4 = require("../actionTypes/lib.js");
function createAsyncRedux(options, defaultRequest) {
    const asyncActionCreatorsMap = (0, lib_3.createAsyncActionCreatorsMap)(options, defaultRequest);
    return {
        asyncActionCreators: (0, lib_3.createAsyncActionCreators)(options, asyncActionCreatorsMap),
        asyncActionCreatorsMap,
        asyncActionTypes: (0, lib_4.createAsyncActionTypes)(options),
        asyncActionTypesMap: (0, lib_4.createAsyncActionTypesMap)(options),
        asyncReducers: (0, lib_1.createAsyncReducers)(options),
        asyncState: (0, lib_2.createAsyncState)()
    };
}
function createDeleteAsyncRedux(options, defaultRequest) {
    return createAsyncRedux(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Delete }), defaultRequest);
}
function createGetAsyncRedux(options, defaultRequest) {
    return createAsyncRedux(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Get }), defaultRequest);
}
function createPatchAsyncRedux(options, defaultRequest) {
    return createAsyncRedux(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Patch }), defaultRequest);
}
function createPostAsyncRedux(options, defaultRequest) {
    return createAsyncRedux(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Post }), defaultRequest);
}
function createPutAsyncRedux(options, defaultRequest) {
    return createAsyncRedux(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Put }), defaultRequest);
}
//# sourceMappingURL=lib.js.map